import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import * as utils from "../../assets/utils";
import Td_Sel from "../../lib/ui/td_sel";
import Pro_add from "./fkn/pro_add";
import Pro_open from "./fkn/pro_open";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pro_Pros extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.bcs = props.store.bcs;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";

    this.state.pra = [];

    this.state.tro = {};
    this.state.wnds = {};
    this.state.typ = "";

    this.selitems = [
        {fkn: 'open', text: 'ÖPPNA'},
        {fkn: 'status', text: 'STATUS'},
        {fkn: 'remove', text: 'TA BORT'}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.pros();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 225;
      css.overflow = "auto";
      return css;
  }
  tab_style(typ) {
      var css = {};
      if(this.state.typ == typ) { css.background = "#009900"; css.color = "#fff"; }
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
  th_style(id) {
      var css = {};
      css.cursor = "pointer";
      if(id == this.state.sortid) css.color = "#080";
      return css;
  }

  pro_add() {
    var self = this;
    var wnds = {};
    wnds.proadd = true;
    wnds.cb = self.pro_close;
    this.setState({ wnds: wnds });
  }
  pro_edit(row) {
    var self = this;
    var wnds = {};
    wnds.proedit = true;
    wnds.pro = row;
    wnds.cb = self.pro_close;
    this.setState({ wnds: wnds });
  }
    pro_close(ctx) {
        ctx.setState({ wnds: {} });
        ctx.pros();
    }
    pro_fkn() {
    }

  pros() {
    var self = this;
    self.setState({typ: "trs", tsa: [] });

    var prm = {};
    prm.req = "bcs.pro.pros";
    prm.typ = "T";

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({pra: ret.rca }, function () {
            self.syncTb("praTable");
        });
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var pra = self.state.pra;
      var sz = this.state.sz_val;

      pra.sort((a,b) => (a.pros00[typ] > b.pros00[typ]) ? 1 : ((b.pros00[typ] > a.pros00[typ]) ? -1 : 0));
      self.setState({ pra: pra, sortid: typ });
   }
  sel_row_fkn(row, sel) {
      //alert(JSON.stringify(fkn));
    if(sel.fkn == "open") {
        //this.sel_gst(row);
    }
    if(sel.fkn == "br") {
    }
  }
   refresh() {
    }
    pr_txt(pid) {
        var text = "";
        pid = pid.toString().tonum(5);
        if( pid == '00000' )  text = 'EJ TILLDELAD';
        if( pid == '00001' )  text = 'Joakim';
        if( pid == '00002' )  text = 'Daniel';
        if( pid == '00003' )  text = 'Stellan';
        if( pid == '00004' )  text = 'Tobias';
        if( pid == '00005' )  text = 'Emmanuel';
        if( pid == '00006' )  text = 'Kari';
        return text;
    }
    kk_txt(kid) {
        var text = kid.ztrim();
        kid = kid.toString().tonum(10);
        var key = "K" + kid;
        if(this.bcs && this.bcs.kro && this.bcs.kro[key]) {
            text = text + " - " + this.bcs.kro[key].kk00.ftg;
        }
        return text;
    }

  render() {
    return (
    <div className="web-app">
    <div className="flex-row">
        <div className="flex-row">
            <button className="btn btn-hw-blue w200" onClick={() => this.pro_fkn() } aria-label="System" >
                FUNKTIONER
            </button>
        </div>

        <div className="flex"></div>

        <div className="flex-row">
        <button className="btn btn-hw-orange w200" onClick={() => this.pro_add() } aria-label="System" >
            LÄGG TILL
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.refresh() } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

        <div id="praTable" className="flex">
          <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.th_style("typ") } onClick={() => this.tb_sort("typ") }>Typ</th>
                <th style={ this.th_style("id") } onClick={() => this.tb_sort("id") }>ID</th>
                <th style={ this.th_style("status") } onClick={() => this.tb_sort("status") }>Sannolikhet</th>
                <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }>Text</th>
                <th style={ this.th_style("pid") } onClick={() => this.tb_sort("pid") }>Ägare</th>
                <th style={ this.th_style("reg") } onClick={() => this.tb_sort("reg") }>Registrerat</th>
                <th style={ this.th_style("due") } onClick={() => this.tb_sort("due") }>Förväntat</th>
                <th style={ this.th_style("value") } onClick={() => this.tb_sort("value") }>Värde</th>
                <th style={ this.th_style("upd") } onClick={() => this.tb_sort("upd") }>Upd</th>
                <th></th>
            </tr>
            </thead>
        </table>
        <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover tb">
            <tbody>
            { this.state.pra.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.pro_edit(row) }>
                <td>{ row.pros00.typ }</td>
                <td>{ utils.toNum( row.pros00.id ) }</td>
                <td>{ row.pros00.proc }</td>
                <td>{ utils.toLang( row.pros00.text ) }</td>
                <td>{ this.pr_txt(row.pros00.pid) }</td>
                <td>{ utils.toDate( row.pros00.reg ) }</td>
                <td>{ utils.toDate( row.pros00.due ) }</td>
                <td>{ utils.toPris( row.pros00.value ) }</td>
                <td>{ row.upd }</td>
                <td>
                    <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
    </div>

        { this.state.wnds.proadd ? <Pro_add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.proedit ? <Pro_open wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
   </div>
  );
    }
}
export default Pro_Pros;
